var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFinancialLimits24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_financial_limits24x24",
    transform: "translate(-7.974 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22639",
    "data-name": "Group 22639",
    transform: "translate(7.974 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22386",
    "data-name": "Group 22386",
    transform: "translate(9.404 8.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42262",
    "data-name": "Path 42262",
    d: "M301.249,258.446a.6.6,0,1,1,.678-.592.308.308,0,0,0,.617,0,1.237,1.237,0,0,0-.986-1.184v-.162a.308.308,0,1,0-.616,0v.162a1.237,1.237,0,0,0-.986,1.184,1.259,1.259,0,0,0,1.295,1.218.6.6,0,1,1-.678.592.308.308,0,0,0-.617,0,1.237,1.237,0,0,0,.986,1.184v.132a.308.308,0,1,0,.616,0v-.132a1.237,1.237,0,0,0,.986-1.184,1.259,1.259,0,0,0-1.295-1.218Z",
    transform: "translate(-299.955 -256.186)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22388",
    "data-name": "Group 22388",
    transform: "translate(12.052 6.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42263",
    "data-name": "Path 42263",
    d: "M386.006,222.285a4.031,4.031,0,0,0-1.641-1.469.306.306,0,0,0-.412.146.314.314,0,0,0,.144.416,3.457,3.457,0,0,1,1.528,4.7.314.314,0,0,0,.128.421.3.3,0,0,0,.145.037.308.308,0,0,0,.272-.166,4.1,4.1,0,0,0-.165-4.089Z",
    transform: "translate(-383.923 -220.785)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22390",
    "data-name": "Group 22390",
    transform: "translate(10.851 6.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42264",
    "data-name": "Path 42264",
    d: "M347.327,209h-.021a.312.312,0,0,0,0,.624h.019a.312.312,0,0,0,0-.624Z",
    transform: "translate(-346.993 -209)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22392",
    "data-name": "Group 22392",
    transform: "translate(6.653 8.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42265",
    "data-name": "Path 42265",
    d: "M214.542,277.874a3.457,3.457,0,0,1-1.528-4.7.314.314,0,0,0-.128-.421.306.306,0,0,0-.417.132,4.1,4.1,0,0,0,.165,4.089,4.032,4.032,0,0,0,1.641,1.469.3.3,0,0,0,.132.031.308.308,0,0,0,.278-.177A.314.314,0,0,0,214.542,277.874Z",
    transform: "translate(-212.002 -272.714)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22394",
    "data-name": "Group 22394",
    transform: "translate(9.896 14.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42266",
    "data-name": "Path 42266",
    d: "M316.7,449h-.018a.312.312,0,0,0,0,.624h.02a.312.312,0,0,0,0-.624Z",
    transform: "translate(-316.375 -449)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22396",
    "data-name": "Group 22396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42267",
    "data-name": "Path 42267",
    d: "M12.084,8.444a1.458,1.458,0,0,0-.139-.258h.812a1.455,1.455,0,0,0,0-2.909h-2.5A1.457,1.457,0,0,0,9.075,3H1.427a1.455,1.455,0,0,0,0,2.909h2.5a1.468,1.468,0,0,0,0,1.644H3.113a1.458,1.458,0,0,0-.892,2.593,1.464,1.464,0,0,0,0,2.277,1.464,1.464,0,0,0,0,2.277,1.458,1.458,0,0,0,.892,2.593H6.792A5.261,5.261,0,0,0,10.667,19,5.384,5.384,0,0,0,12.084,8.444Zm.674-2.533a.822.822,0,0,1,0,1.644H5.111a.822.822,0,0,1,0-1.644ZM1.427,5.277a.822.822,0,0,1,0-1.644H9.075a.822.822,0,0,1,0,1.644ZM3.112,8.186H10.76a.8.8,0,0,1,.354.083q-.222-.019-.447-.019A5.258,5.258,0,0,0,6.912,9.83h-3.8a.822.822,0,0,1,0-1.644Zm0,2.277H6.375a5.389,5.389,0,0,0-.8,1.644H3.112a.822.822,0,0,1,0-1.644Zm0,2.277h2.32a5.449,5.449,0,0,0-.019,1.644h-2.3a.822.822,0,0,1,0-1.644Zm0,3.921a.822.822,0,0,1,0-1.644H5.541A5.387,5.387,0,0,0,6.29,16.66Zm7.554,1.707a4.744,4.744,0,1,1,4.682-4.743A4.738,4.738,0,0,1,10.667,18.367Z",
    transform: "translate(.026 -3)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFinancialLimits24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_financial_limits24x24.9fff65f856c1b58bfb1b1223e4f63ef4.svg";